import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthProvider, PocketbaseService } from '../../services/pocketbase.service';
import { Router } from '@angular/router';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { faBrandGoogle, faBrandMicrosoft, faBrandFacebookF, faBrandInstagram, faBrandApple, faBrandDiscord } from '@ng-icons/font-awesome/brands';

@Component({
    selector: 'app-social-login',
    imports: [NgIconComponent],
    templateUrl: './social-login.component.html',
    styleUrl: './social-login.component.scss',
    providers: [provideIcons({ faBrandGoogle, faBrandMicrosoft, faBrandFacebookF, faBrandInstagram, faBrandApple, faBrandDiscord })]
})
export class SocialLoginComponent {
  @Input()
  public returnUrl: string = '/';

  @Output()
  public onError: EventEmitter<any> = new EventEmitter();

  constructor(private readonly pocketbaseService: PocketbaseService, private router: Router) { }

  handleGoogleLogin() {
    const w = this.pocketbaseService.openBrowserPopup();

    this.pocketbaseService.socialLogin(AuthProvider.Google, w).then(() => {
      this.router.navigateByUrl(this.returnUrl);
    }).catch((e) => {
      this.onError.emit(e);
    });
  }

  handleMicrosoftLogin() {
    const w = this.pocketbaseService.openBrowserPopup();

    this.pocketbaseService.socialLogin(AuthProvider.Microsoft, w).then(() => {
      this.router.navigateByUrl(this.returnUrl);
    }).catch((e) => {
      this.onError.emit(e);
    });
  }

  handleDiscordLogin() {
    const w = this.pocketbaseService.openBrowserPopup();

    this.pocketbaseService.socialLogin(AuthProvider.Discord, w).then(() => {
      this.router.navigateByUrl(this.returnUrl);
    }).catch((e) => {
      this.onError.emit(e);
    });
  }
}
